<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      fixed
      fab
      bottom
      right
      color="primary"
      slot="activator"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Neue Branche erstellen</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Branchenname"
                required
                v-model="branch.title"
                :disabled="loading"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Icon"
                required
                v-model="branch.icon"
                :disabled="loading"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>* Pflichtfelder</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="save()" :loading="loading">Erstellen</v-btn>
        <v-btn color="error" @click.native="dialog = false; company = {}">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';


export default {
  name: 'DlgBranchNew',
  components: {
    // VueEditor,
  },
  data() {
    return {
      dialog: false,
      branch: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      branchCreate: 'branch/create',
      branchRead: 'branch/read',
    }),
    save() {
      this.loading = true;
      this.branchCreate(this.branch).then((res) => {
        this.loading = false;
        if (res) {
          this.branchRead();
          this.branch = {};
          this.dialog = false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
